/*! Oruga v0.8.12 | MIT License | github.com/oruga-ui/oruga */
import { _ as _sfc_main } from "./Tooltip.vue_vue_type_script_setup_true_lang-C1GHI2GD.mjs";
import { b as registerComponent } from "./config-C1k5NuG7.mjs";
const index = {
  install(app) {
    registerComponent(app, _sfc_main);
  }
};
export {
  _sfc_main as OTooltip,
  index as default
};
//# sourceMappingURL=tooltip.mjs.map
